import classNames from 'classnames';
import React from 'react';

type Props = {
  appIcon?: string,
  appName?: string,
  showAppNameClasses?: string,
  hideAppNamesClasses?: string,
  children?: React.ReactNode,
  brandUrl?: string,

  onBrandClick?: () => void,
};

type State = {
  showMenu: boolean;
};

class NavigationBar extends React.Component<Props, State> {
  constructor (props: Props) {
    super(props);

    this.state = {
      showMenu: false
    };

    this.handleToggleMenu = this.handleToggleMenu.bind(this);
  }

  handleToggleMenu () {
    this.setState((state) => {
      return {showMenu: !state.showMenu};
    });
  }

  renderBrand (withName: boolean) {
    const { appIcon, appName, brandUrl, onBrandClick } = this.props;

    if (withName) {
      if (brandUrl != null) {
        return (
          <a href={brandUrl} className='esko_navbar-brand esko_brand'>
            <img src={appIcon} alt='' height='28' width='28' />
            {appName}
          </a>
        );
      } else if (onBrandClick != null) {
        return (
          <a className='esko_navbar-brand esko_brand' role='button' onClick={onBrandClick}>
            <img src={appIcon} alt='' height='28' width='28' />
            {appName}
          </a>
        );
      }

      return (
        <div className='esko_navbar-brand esko_brand'>
          <img src={appIcon} alt='' height='28' width='28' />
          {appName}
        </div>
      );
    } else {
      if (brandUrl != null) {
        return (
          <a href={brandUrl} className='esko_navbar-brand'>
            <img src={appIcon} alt='' height='28' width='28' />
          </a>
        );
      } else if (onBrandClick != null) {
        return (
          <a className='esko_navbar-brand esko_brand' role='button' onClick={onBrandClick}>
            <img src={appIcon} alt='' height='28' width='28' />
          </a>
        );
      }

      return (
        <div className='esko_navbar-brand'>
          <img src={appIcon} alt='' height='28' width='28' />
        </div>
      );
    }
  }

  override render (): React.ReactNode {
    const { children } = this.props;

    const hasChildren = !!children;

    const showAppNameClasses: string = this.props.showAppNameClasses ? this.props.showAppNameClasses : 'esko_visible-lg-inline esko_visible-md-inline';
    const hideAppNamesClasses: string = this.props.hideAppNamesClasses ? this.props.hideAppNamesClasses : 'esko_visible-sm-inline  esko_visible-xs-inline';

    return (
      <nav className='esko_navbar'>
        <div className='esko_container'>
          <div className='esko_navbar-header'>
            <button
              type='button'
              className={classNames('esko_navbar-toggle', { 'esko_collapsed': hasChildren, hidden: !hasChildren })}
              data-target='#esko-navbar'
              aria-expanded='false'
              onClick={this.handleToggleMenu}
            >
              <span className='esko_sr-only'>Toggle navigation</span>
              <span className='esko_icon-bar' />
              <span className='esko_icon-bar' />
              <span className='esko_icon-bar' />
            </button>
            <div className={showAppNameClasses}>
              {this.renderBrand(true)}
            </div>
            <div className={hideAppNamesClasses}>
              {this.renderBrand(false)}
            </div>
          </div>
          <div id='esko-navbar' className={classNames('esko_collapse esko_navbar-collapse', {'in': this.state.showMenu})}>
            {children}
          </div>
        </div>
      </nav>
    );
  }
}

export default NavigationBar;
